import React, { PureComponent } from 'react'

class EmptyData extends PureComponent {
    render() {
        return (
            <div style={{
                margin: 'auto',
                border: '3px solid rgb(21, 152, 151)',
                padding: '10%',
                backgroundColor: '#a9a9a940'
            }}>
                <div style={{
                    textAlign: 'center'
                }}>
                    <p><b>Note: </b>Data tidak ditemukan.</p>
                </div>
            </div>
        )
    }
}

export default EmptyData
